import React from 'react'
import { browserHistory } from 'react-router'

import WorkOrderEdit from '../../components/WorkOrder/WorkOrderEdit.jsx'

import {user} from '../../core/controllers/user';

export default class WorkOrderTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }
    /*
    have handler for saveLeaseData pass to leaseEdit component so that
    when there is a valid leaseID, it calls the lease api
    to retrieve the lease data alone

    */

    render(){
        var newWorkOrder = true;
        if(this.props.workOrderID.length > 0 && this.props.workOrderID !== 'new'){
            newWorkOrder = false;
        }

        return (
            <div>
                <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                <WorkOrderEdit workOrderID={this.props.workOrderID} newWorkOrder={newWorkOrder} />
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/WorkOrder/WorkOrder.jsx